import { render, staticRenderFns } from "./PieChat.vue?vue&type=template&id=5cb5d3fd"
import script from "./PieChat.vue?vue&type=script&lang=js"
export * from "./PieChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports